module.exports = __webpack_public_path__ + "img/ups.247520bc.png";